<div
  ngpToggleGroup
  [id]="effectiveId"
  [ngpToggleGroupType]="multiple ? 'multiple' : 'single'"
  [ngpToggleGroupAllowDeselection]="multiple"
  [ngpToggleGroupValue]="groupValue"
  [ngpToggleGroupDisabled]="isDisabled()"
  (ngpToggleGroupValueChange)="onValueChange($event)"
  [attr.role]="multiple ? 'group' : 'radiogroup'"
  [attr.aria-invalid]="errorState ? 'true' : null"
  [class]="'sui-button-group sui-button-group--' + size"
  [class.sui-button-group--invalid]="errorState"
>
  @for (option of options; track $index; let i = $index) {
    <button
      type="button"
      class="sui-button-group__item"
      [class.sui-button-group__item--icon-only]="!option.label"
      ngpToggleGroupItem
      [ngpToggleGroupItemValue]="key(i)"
      [ngpToggleGroupItemDisabled]="effectiveDisabled(option)"
      [disabled]="effectiveDisabled(option)"
      [attr.role]="multiple ? 'checkbox' : 'radio'"
      [attr.aria-label]="option.ariaLabel || null"
      [suiTooltip]="option.tooltip ?? ''"
      [suiTooltipDisabled]="!option.tooltip"
      suiTooltipContainer="auto"
    >
      @if (option.icon) {
        <span class="sui-button-group__icon" aria-hidden="true">
          <fa-icon [icon]="option.icon"></fa-icon>
        </span>
      }
      @if (option.label) {
        {{ option.label }}
      }
    </button>
  }
</div>
